const distinct = (value, index, self) => {
	return self.indexOf(value) === index;
}

function elementInViewport(el) {
	const fn = (top, oversize, offset) => {
		return (
			(top + oversize + offset) >= 0
			&& top < ((window.innerHeight || document.documentElement.clientHeight) + offset)
		)
	}

	if (!el) return false;

	var rect = el.getBoundingClientRect();

	var elSize = el.offsetHeight;
	var oversize = 0;

	if (elSize > window.innerHeight) {
		oversize = elSize - window.innerHeight;
	}

	var result = fn(rect.top, oversize, 0);

	if (result) {
		if (el.id == 'footer') {
			//result = fn(rect.top, oversize, -100);
		}
	}

	return result;
}

const pageTop = () => {
	const _doc = document.documentElement;
	return (window.pageYOffset || _doc.scrollTop) - (_doc.clientTop || 0);
}

const pageLeft = () => {
	const _doc = document.documentElement;
	return (window.pageXOffset || _doc.scrollLeft) - (_doc.clientLeft || 0);
}

const toRect = (data) => {
	return { left: data.x, top: data.y, right: data.x + data.width, bottom: data.y + data.height, width: data.width, height: data.height };
}

const calculateElementPosition = (el) => {
	const rect = el.getBoundingClientRect();

	const x = Math.abs(rect.x);
	var y = rect.y;
	// if (y < 0) {
		// y = y + pageTop();
	// }
	const width = Math.abs(rect.width);
	const height = Math.abs(rect.height);

	return { x: x, y: y, width: width, height: height };
}

const addClassIfNotExists = (el, _class) => {
	if (el) {
		if (!el.classList.contains(_class)) {
			el.classList.add(_class);
		}
	} else {
		console.error("element is null");
	}
}

const removeClassIfExists = (el, _class) => {
	if (!el) return;
	
	if (el.classList.contains(_class)) {
		el.classList.remove(_class);
	}
}

const toggleClass = (el, _class) => {
	if (el.classList.contains(_class)) {
		el.classList.remove(_class);
	} else {
		el.classList.add(_class);
	}
}

const calculateOverlapArea = (rect1, rect2) => {
	// const x_overlap = Math.max(0, Math.min(rect1.right, rect2.right) - Math.max(rect1.left, rect2.left));
	// const y_overlap = Math.max(0, Math.min(rect1.bottom, rect2.bottom) - Math.max(rect1.top, rect2.top));

	const x_overlap = Math.min(rect1.right, rect2.right) - Math.max(rect1.left, rect2.left);
	const y_overlap = Math.min(rect1.bottom, rect2.bottom) - Math.max(rect1.top, rect2.top);
	const result = Math.abs(x_overlap * y_overlap);

	// console.log('calculateOverlapArea  --->', result);
	return result;
}

const calculateArea = (rect) => {
	return (rect.bottom - rect.top) * (rect.right - rect.left);
}


export default {
	elementInViewport,
	distinct,
	pageTop,
	pageLeft,
	toRect,
	addClassIfNotExists,
	removeClassIfExists,
	toggleClass,
	calculateOverlapArea,
	calculateArea,
	calculateElementPosition
}